import React, { useMemo } from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Pages from "routes";
import { getCustomTheme } from "shared/styles/theme";
import { SnackbarProvider } from "notistack";
import "./styles.scss";
import "pages";
// import reportWebVitals from "./reportWebVitals";

import { Onboarding } from "components";
import { InactivityPinLock } from "components";
import "tutorials";
import { ThemeProvider, useThemeSettings, NotificationsProvider, VoicePreferencesProvider } from "shared/contexts";

const ThemedApp = () => {
	const { resolvedMode, colors } = useThemeSettings();

	const theme = useMemo(() => getCustomTheme(resolvedMode, colors), [resolvedMode, colors]);

	return (
		<MuiThemeProvider theme={theme}>
			<CssBaseline />
			<SnackbarProvider maxSnack={3}>
				<NotificationsProvider>
					<VoicePreferencesProvider>
						<Pages />
						<Onboarding />
						<InactivityPinLock />
					</VoicePreferencesProvider>
				</NotificationsProvider>
			</SnackbarProvider>
		</MuiThemeProvider>
	);
};

const App = () => {
	return (
		<ThemeProvider>
			<ThemedApp />
		</ThemeProvider>
	);
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);

// Se você quiser começar a medir o desempenho do seu aplicativo, passe uma função
// para registrar os resultados (por exemplo: reportWebVitals(console.log))
// ou envie para um endpoint de análise. Saiba mais: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);

if ("serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker.register("/sw.js").catch((err) => console.log("Erro ao registrar SW:", err));
	});
}
